var SELECTOR = 'span.jump-link[data-title]';

function init() {
    try {
        var grid = document.querySelector('.anchor-toc__grid');
        if (!grid) return;

        function addLink(anchor) {
            var id = anchor.id;
            var title = anchor.getAttribute('data-title');
            if (!id || !title) return;

            // Avoid duplicates
            if (grid.querySelector('a[href="#' + id + '"]')) return;

            var item = document.createElement('div');
            item.className = 'anchor-toc__item u-mrg-btm-half';

            var a = document.createElement('a');
            a.className = 'anchor-toc__link u-inline-block u-color-black';
            a.href = '#' + id;
            a.textContent = title;

            item.appendChild(a);
            grid.appendChild(item);
        }

        document.querySelectorAll(SELECTOR).forEach(addLink);

        // Pick up anchors added after initial load (e.g. personalised content)
        var main = document.querySelector('main');
        if (main) {
            new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType !== Node.ELEMENT_NODE) return;
                        if (node.matches(SELECTOR)) addLink(node);
                        node.querySelectorAll(SELECTOR).forEach(addLink);
                    });
                });
            }).observe(main, { childList: true, subtree: true });
        }
    } catch (e) {
        console.error('[anchor-toc]', e);
    }
}

export { init };
